module.exports = __webpack_public_path__ + "img/notification.900cd931.svg";